<template>
  <b-row class="table-action-buttons flex-nowrap" v-if="route !== ''">
    <router-link
      v-if="!hiddenEditButton"
      v-permission="`update ${permission}`"
      v-role="role"
      title="ویرایش"
      v-b-tooltip.hover
      :to="editPath"
    >
      <i class="mdi mdi-pencil font-size-18 text-primary"></i>
    </router-link>
    <i
      v-if="!hiddenDeleteButton"
      v-permission="`delete ${permission}`"
      v-role="role"
      title="حذف"
      v-b-tooltip.hover
      @click="handleDeleteOnClick"
      class="mdi mdi-trash-can font-size-18 text-danger mx-3"
      style="cursor: pointer"
    ></i>
    <router-link
      v-if="!hiddenShowButton"
      title="مشاهده"
      v-b-tooltip.hover
      :to="showPath"
    >
      <i class="mdi mdi-eye font-size-18 text-success"></i>
    </router-link>
    <slot name="extra-buttons"></slot>
  </b-row>
  <b-row v-else class="table-action-buttons flex-nowrap">
    <span
      v-if="!hiddenEditButton"
      :v-permission="`update ${permission}`"
      :v-role="role"
      title="ویرایش"
      v-b-tooltip.hover
      @click="handleEditOnClick"
      ><i class="mdi mdi-pencil font-size-18 text-primary"></i
    ></span>
    <span
      v-if="!hiddenDeleteButton"
      :v-permission="`delete ${permission}`"
      :v-role="role"
      title="حذف"
      v-b-tooltip.hover
      @click="handleDeleteOnClick"
      class="mx-2"
      ><i
        class="mdi mdi-trash-can font-size-18 text-danger mx-3"
        style="cursor: pointer"
      ></i
    ></span>

    <span
      v-if="!hiddenShowButton"
      title="مشاهده"
      v-b-tooltip.hover
      @click="handleShowOnClick"
      ><i class="mdi mdi-eye font-size-18 text-success"></i
    ></span>
    <slot name="extra-buttons"></slot>
  </b-row>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'table-action-buttons',
  props: {
    hiddenEditButton: {
      type: Boolean,
      default: false,
    },
    hiddenDeleteButton: {
      type: Boolean,
      default: false,
    },
    hiddenShowButton: {
      type: Boolean,
      default: false,
    },
    route: {
      type: String,
      default: '',
    },
    recordId: {
      type: Number,
      required: true,
    },
    deleteTitle: {
      type: String,
      default: '',
    },
    permission: {
      type: String,
      default: '',
    },
    faTitle: {
      type: String,
      required: true,
    },
    deleteParams: {
      type: Object,
      default() {
        return {}
      },
    },
    deleteRoute: {
      type: String,
      default: '',
    },
    editRoute: {
      type: [String, Object],
      default: '',
    },
    showRoute: {
      type: [String, Object],
      default: '',
    },
    role: {
      type: String,
      default: '',
    },
  },
  computed: {
    editPath() {
      if (this.editRoute !== '') {
        return this.editRoute
      } else {
        return { name: `${this.route}.edit`, params: { id: this.recordId } }
      }
    },
    showPath() {
      if (this.showRoute !== '') {
        return this.showRoute
      } else {
        return { name: `${this.route}.show`, params: { id: this.recordId } }
      }
    },
  },
  methods: {
    handleEditOnClick() {
      this.$emit('edit-click')
    },
    handleShowOnClick() {
      this.$emit('show-click')
    },
    handleDeleteOnClick() {
      Swal.fire({
        title: `حذف ${this.faTitle}`,
        text: `آیا از حذف ${this.deleteTitle} مطمئن هستید؟ `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'بله',
        cancelButtonText: 'خیر',
      }).then((result) => {
        if (result.value) {
          this.deleteRecord()
        }
      })
    },
    deleteRecord() {
      let route = `${this.route}/${this.recordId}`
      if (this.deleteRoute !== '') {
        route = this.deleteRoute
      }
      this.$axios
        .delete(route, {
          headers: {},
          params: this.deleteParams,
        })
        .then(() => {
          Swal.fire('موفق!', `${this.faTitle}  با موفقیت حذف شد.`, 'success')
          this.$emit('deleted')
        })
        .catch((er) => {
          Swal.fire('ناموفق!', er.response.data.error, 'error')
        })
    },
  },
}
</script>

<style scoped>
.table-action-buttons button {
  font-size: 12px;
}
</style>
